<template>
    <div class="similar-search-wrapper">
        <ConditionSearch
            class="similar-search"
            @searchInputChange="searchInputChange"
            @showSearchList="showSearchList"
            :resData="resData"
            :hasInput="hasInput"
            :placeholder="placeholder"
        ></ConditionSearch>
    </div>
</template>

<script>
import ConditionSearch from "@/views/zhiji/bComponents/inputs/ConditionSearch";

export default {
    name: "SimilarSearch",
    props: ["placeholder"],
    data() {
        return {
            resData: [],
            hasInput: false
        };
    },
    components: {
        ConditionSearch
    },
    methods: {
        searchInputChange(data) {
            this.$emit("searchSimilar", data);
        },
        showSearchList(data) {
            this.$emit("searchSimilar", {
                keywords: data.searchInfo
            });
        }
    }
};
</script>

<style lang="less" scoped>
.similar-search-wrapper {
    padding: 10px 0 10px 10px;
    border-bottom: 1px solid #d8e4f0;
    background: #fff;
    .similar-search {
        margin-right: 16px;
        position: relative;
        width: 500px;
    }
}
</style>
